import { createSlice } from '@reduxjs/toolkit'

let user = null;

try {
  const authUser = localStorage.getItem("auth-user");
  user = authUser ? JSON.parse(authUser) : null;
} catch (err) {
  console.error("Invalid auth-user in localStorage:", err);
  localStorage.removeItem("auth-user");
}
const initialState = {
  user,
  profileDetails: {},
  openNotificationMenu: false,
  notificationLoading: false,
  notificationSuccess: {},
  notificationError: "",
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
    },
    updateToken: (state, action) => {
      const userData = {
        ...JSON.parse(localStorage.getItem('auth-user')),
        cityId: action?.payload?.cityId,
        token: action?.payload?.token
      };
      authSlice.caseReducers.loginSuccess(state, { payload: userData });
      localStorage.setItem('auth-user', JSON.stringify(userData));
    },
    loginClear: (state, action) => {
      state.user = null;
    },
    userProfileDetails: (state, action) => {
      state.profileDetails = action.payload
    },
    openNotificationDropdownMenu: (state, action) => {
      state.openNotificationMenu = true;
    },
    closeNotificationDropdownMenu: (state) => {
      state.openNotificationMenu = false;
    },
    setNotificationLoading: (state) => {
      state.notificationLoading = true
    },
    setNotificationSuccess: (state, action) => {
      state.notificationLoading = false;
      state.notificationSuccess = action.payload;
      state.notificationError = "";
    },
    setNotificationError: (state, action) => {
      state.notificationLoading = false;
      state.notificationSuccess = {};
      state.notificationError = action.error?.message;
    }

  },
})

// Action creators are generated for each case reducer function
export const { setNotificationLoading,
  setNotificationSuccess,
  setNotificationError,
  loginSuccess, loginClear, userProfileDetails, openNotificationDropdownMenu, closeNotificationDropdownMenu, updateToken } = authSlice.actions

export default authSlice.reducer;